import {
  Archive,
  InsertChart,
  History,
  People,
  Gavel,
  Shield,
  Badge,
  Business,
  DeleteOutline,
  MonetizationOn,
  Category,
  VerifiedUser,
  AccountBalance,
  LocationOn,
  SupportAgent,
  ContactSupport,
  ThumbUp,
  Campaign,
  School,
} from "@mui/icons-material";
import {
  DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE,
} from "../../globals/utils/duplicateAccountsMergeFeature";

export const IU_MANAGEMENT_PAGE_TITLE = {
  data: "Data Management",
  account: "Account Management",
  system: "System Management",
};

export const IU_DATA_MANAGEMENT_LINKS = [
  {
    name: "Bond Archives",
    path: "/vermost_bond_archives",
    feature: "bond_archives",
    icon: Archive,
  },
  {
    name: "Analytics",
    path: "/analytics",
    feature: "analytics",
    icon: InsertChart,
  },
  {
    name: "Create Historic Bond",
    path: "/bond-creation-outsider-historic",
    feature: "create_historic_bonds",
    icon: History,
  },
];

export const ADMIN_DATA_MANAGEMENT_LINKS = [
  { name: "Bond Archives", path: "/vermost_bond_archives", icon: Archive },
  { name: "Analytics", path: "/analytics", icon: InsertChart },
  {
    name: "Create Historic Bond",
    path: "/bond-creation-outsider-historic",
    icon: History,
  },
];

export const IU_ACCOUNT_MANAGEMENT_LINKS = [
  {
    name: "Internal Users",
    path: "/vermost_internal_users",
    feature: "internal_users",
    icon: People,
  },
  {
    name: "Law Firms",
    path: "/vermost_lawfirm_list",
    feature: "law_firms",
    icon: Gavel,
  },
  {
    name: "Professional Guardians",
    path: "/vermost-professional-guardian-list",
    feature: "professional_guardians",
    icon: Shield,
  },
  {
    name: "Legal Service Paralegals",
    path: "/vermost_paralegals_list",
    feature: "paralegals",
    icon: Badge,
  },
  {
    name: "Law Firm Users",
    path: "/vermost_law_firm_users",
    feature: "law_firm_users",
    icon: Business,
  },
];

export function buildAdminAccountManagementLinks(duplicateAccountsMergeEnabled) {
  return [
    [
      { name: "Internal Users", path: "/vermost_internal_users", icon: People },
      { name: "Law Firms", path: "/vermost_lawfirm_list", icon: Gavel },
      { name: "Law Firm Users", path: "/vermost_law_firm_users", icon: Business },
    ],
    [
      {
        name: "Professional Guardians",
        path: "/vermost-professional-guardian-list",
        icon: Shield,
      },
      {
        name: "Legal Service Paralegals",
        path: "/vermost_paralegals_list",
        icon: Badge,
      },
      {
        name: "Duplicate Accounts",
        path: "/vermost_duplicate_accounts",
        icon: DeleteOutline,
        disabled: !duplicateAccountsMergeEnabled,
        disabledHint: DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE,
      },
    ],
  ];
}

export const IU_SYSTEM_MANAGEMENT_LINKS = [
  {
    name: "Manage Premiums",
    path: "/vermost_premiums_manager",
    feature: "premiums",
    icon: MonetizationOn,
  },
  {
    name: "Bond Types",
    path: "/bondtypes",
    feature: "bond_types",
    icon: Category,
  },
  {
    name: "Bond Numbers",
    path: "/bond_numbers",
    feature: "bond_numbers",
    icon: VerifiedUser,
  },
  {
    name: "Carriers",
    path: "/vermost_carrier_list",
    feature: "carriers",
    icon: AccountBalance,
  },
  {
    name: "States",
    path: "/states",
    feature: "states",
    icon: LocationOn,
  },
  {
    name: "All Enhancement Requests",
    path: "/view-enhancement-requests",
    feature: "enhancement_request",
    icon: SupportAgent,
  },
  {
    name: "Support Request",
    path: "/admin/support-requests",
    feature: "support_requests",
    icon: ContactSupport,
  },
];

export const ADMIN_SYSTEM_MANAGEMENT_LINKS = [
  [
    { name: "Approve Bonds", path: "/vermost_approve_bonds", icon: ThumbUp },
    {
      name: "Manage Premiums",
      path: "/vermost_premiums_manager",
      icon: MonetizationOn,
    },
  ],
  [
    { name: "Bond Types", path: "/bondtypes", icon: Category },
    { name: "Bond Numbers", path: "/bond_numbers", icon: VerifiedUser },
    { name: "Carriers", path: "/vermost_carrier_list", icon: AccountBalance },
    { name: "Announcements", path: "/announcements", icon: Campaign },
  ],
  [
    { name: "States", path: "/states", icon: LocationOn },
    { name: "Obligees", path: "/obligees", icon: Business },
  ],
  [
    { name: "Law Schools", path: "/law_schools", icon: School },
    {
      name: "All Enhancement Requests",
      path: "/view-enhancement-requests",
      icon: SupportAgent,
    },
    {
      name: "Support Request",
      path: "/admin/support-requests",
      icon: ContactSupport,
    },
  ],
];
